import { CREATE_COMPONENT_COMPONENT_SELECTED } from 'app/CanvasComponent/const';

/**
 * action creator to create a new master component
 *
 * @param {object} component - component payload for the new master component
 * @returns {object} action
 */
export const createNewComponent = component => ({
  type: CREATE_COMPONENT_COMPONENT_SELECTED,
  component
});
